<template>
  <div
    style="
      width: 100vw;
      height: 100vh;
      overflow: hidden;
      position: absolute;
      z-index: 9999;
    "
  >
    <div
      style="
        width: 100vw;
        height: 80px;
        background-color: #274986;
        display: flex;
        justify-content: space-between;
      "
    >
      <div class="logoBox">气候极端事件风险防范决策支持系统</div>
      <div class="item-box">
       
        <router-link to="/heat">
          <div
            :class="[active == 1 ? 'item item1  active' : 'item item1']"
            @click="getPage(1)"
          >
            极端高温
          </div>
        </router-link>
        <router-link to="/cold">
          <div
            :class="[active == 2 ? 'item  active' : 'item ']"
            @click="getPage(2)"
          >
            极端低温
          </div>
        </router-link>
        <router-link to="/rain">
          <div
            :class="[active == 3 ? 'item  active' : 'item ']"
            @click="getPage(3)"
          >
            极端降水
          </div>
        </router-link>
        <router-link to="/dry">
          <div
            :class="[active == 4 ? 'item  active' : 'item ']"
            @click="getPage(4)"
          >
            极端干旱
          </div>
        </router-link>
        <router-link to="/typhoon">
          <div
            :class="[active == 5 ? 'item  active' : 'item ']"
            @click="getPage(5)"
          >
            台风
          </div>
        </router-link>
        <router-link to="clime">
          <div
            :class="[active == 6 ? 'item  active' : 'item ']"
            @click="getPage(6)"
          >
            气候变化
          </div>
        </router-link>
        <router-link to="/sce">
          <div
            :class="[active == 7 ? 'item  active' : 'item']"
            @click="getPage(7)"
          >
          模拟能力评估
          </div>
        </router-link>
        <router-link to="/ha">
          <div
            :class="[active == 8 ? 'item  active' : 'item']"
            @click="getPage(8)"
          >
          危险性评估
          </div>
        </router-link>
      </div>
    </div>
    <div class="view-box">
      <router-view> </router-view>
    </div>
  </div>
</template>

<script>
import { MapCreate } from "./map/mapImport";
export default {
  data() {
    return {
      map: "",
      active: 1,
    };
  },
  mounted() {
    this.initDate();
  },
  methods: {
    initDate() {},
    getPage(e) {
      // console.log(e);
      this.active = e;
      // console.log(this.active);
    },
  },
};
</script>

<style>
.my-layer-item {
  text-align: center;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: black;
}

.logoBox {
  color: white;
  font-size: 25px;
  font-weight: 600;
  line-height: 100px;
  padding-left: 25px;
}

.item-box {
  height: 80px;
  margin-top: 20px;
  display: flex;
}

.item {
  min-width: 100px;
  height: 60px;
  background-color: #3cbaf0;
  /* margin-right: 10px; */
  line-height: 60px;
  font-size: 18px;
  text-align: center;
  border: 1px solid #274986;
  font-weight: 600;
}

.item1 {
  border-radius: 10px 0 0 0;
}

.active {
  background-color: #1a69cf;
  color: white;
}

.view-box {
  width: 100vw;
  height: 93vh;
}
.popper__arrow {
  left: 80px !important;
}
.el-picker-panel {
  left: -40px !important;
}
</style>